<template>
  <div
    :class="['btn', {
      disabled: !disabled
    }]"
    @click="handleClick"
  >
    <slot/>
  </div>
</template>

<script>
export default {
  name: 'base-button',
  props: {
    disabled: {
      type: Boolean,
      default: !0
    }
  },
  methods: {
    handleClick() {
      this.$emit('click');
    }
  }
};
</script>

<style lang="scss" scoped>
.btn {
  cursor: pointer;
  text-align: center;
  border-radius: 4px;
  padding:7px 15px;
  background-color: $menu-child;
  @include s-c-w(14, #fff);
  &.disabled {
    background-color: #DDE7F0;
  }
}
</style>
